import React from "react";

import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableHeader,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";

import { PencilIcon, TrashIcon } from "@heroicons/react/16/solid";

export function TableComponent({
  data,
  headers,
  onEdit,
  onDelete,
  showActions = true,
}) {
  return (
    <Table className="">
      <TableHead>
        <TableRow>
          {headers.map(({ label }) => (
            <TableHeader>{label}</TableHeader>
          ))}
          {showActions && <TableHeader>Action</TableHeader>}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((item, index) => (
          <TableRow key={index}>
            {headers.map(({ key }) => (
              <TableCell>{item[key]}</TableCell>
            ))}
            {showActions && (
              <TableCell>
                <div className=" flex flex-row gap-x-2">
                  <Button
                    outline
                    onClick={() => onEdit(item, index)}
                  >
                    <PencilIcon />
                  </Button>
                  <Button
                    outline
                    onClick={() => onDelete(item, index)}
                  >
                    <TrashIcon />
                  </Button>
                </div>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
